const replaceCommas = (commaNumber: string): number =>
  Number(commaNumber.toString().replace(/,/g, '.'));

export default replaceCommas;
